import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Vocabulary from './Vocabulary'
import CreateVocabulary from './CreateVocabulary'
import VocabularyDetail from './VocabularyDetail'
import AiGeneratedVocabulary from './AiGeneratedVocabulary'
import ManualVocabulary from './ManualVocabulary'

const VocabularyRoutesTeacher = () => {
    return (
        <>
            <Routes>
                <Route
                    path='/'
                    element={<Vocabulary />}
                />
                <Route
                    path='/create-vocabulary'
                    element={<CreateVocabulary />}
                />
                <Route
                    path='/create-vocabulary/AI'
                    element={<AiGeneratedVocabulary />}
                />
                <Route
                    path='/create-vocabulary/manually'
                    element={<ManualVocabulary />}
                />
                <Route
                    path='/:id'
                    element={<VocabularyDetail />}
                />

            </Routes>
        </>
    )
}

export default VocabularyRoutesTeacher